import {observer} from "mobx-react";
import {Pager, ScrollTable, Searchbar} from "../../ui";
import {slsOverviewStore, slsUserStore} from "../../../store";
import {PageContentTitle} from "@kroschke/react-ui";
import {SlsItemFilterbar} from "./SlsItemFilterbar";
import {SlsProcessListRow} from "./SlsProcessListRow";

const SlsProcessList = observer(function SlsProcessList() {
    return <>
        <PageContentTitle
            actionItem={
                <SlsItemFilterbar
                    users={slsUserStore.items}
                />
            }
        >
            <Searchbar placeholder={"Kennung"}/>
        </PageContentTitle>
        <ScrollTable>
            <thead>
            <tr>
                <th>Kennung</th>
                <th>Quelle</th>
                <th>Benutzer</th>
                <th>Kunde</th>
                <th style={{width:'10em'}}>Status</th>
                <th style={{width: '4em'}}>Pos</th>
                <th style={{width: '4em'}}></th>
            </tr>
            </thead>
            <tbody>
            {slsOverviewStore.items.map((val, index) => (
                <SlsProcessListRow val={val} key={val.id}/>
            ))
            }
            </tbody>
        </ScrollTable>
        <Pager total={slsOverviewStore.pages}/>
    </>
})

export {
    SlsProcessList
}
